<template>
	<div class="content-box">
		<div class="operator">
			<div class="operator-col">
				<warehouse-input v-model="filterWarehouse"></warehouse-input>
			</div>
      <div class="operator-col">
        <supplier-input v-model="filterSupplier"></supplier-input>
      </div>
			<div class="operator-col">
				<hispickup v-model="filterHisDate"></hispickup>
			</div>
			<div class="operator-col">
				<enum-filter
					size="mini"
					v-model="filterStatus.index"
					clearable
					data-model-name="Transaction"
					field="status"
				></enum-filter>
			</div>
      <div class="operator-col">
        <enum-filter
            size="mini"
            v-model="filterExpressType.index"
            placeholder="发货类型"
            suffix-icon="el-icon-caret-bottom"
            clearable
            data-model-name="Transaction"
            field="express_type"
        ></enum-filter>
      </div>
			<div class="operator-col">
				<el-input
					size="mini"
					v-model="filterTableSearch"
					placeholder="商品名"
					suffix-icon="el-icon-search"
				></el-input>
			</div>
		</div>
		<curd-table
			ref="listTable"
			:data-model="listDataModel"
			:fields="tableFields"
			@doedit="handleEdit($event)"
			:date-filter="filterHisDate"
			:warehouse-filter="filterWarehouse"
			:search-filter="filterTableSearch"
			:expand-fields="expandTableFields"
			:has-delete="false"
			:kv-filter="kvFilter"
		>
			<template slot="listOp" slot-scope="scope">
				<el-button size="mini" type="text" @click="goTxInfo(scope.row._id)">详情</el-button>
				<el-button size="mini" type="text" @click="goTxEdit(scope.row._id)" v-if="hasEdit(scope.row)">编辑</el-button>
				<template v-if="scope.row.type.index==20">
					<!-- 出库操作 -->
				</template>
				<template v-else-if="scope.row.type.index==21">
					<!-- 入库操作 -->
					<el-button
						size="mini"
						type="text"
						@click="doHasVerify(scope.row._id)"
						v-if="scope.row.status.index==11 "
					>审核</el-button>
					<el-button
						size="mini"
						type="text"
						@click="doDeleteTx(scope.row._id)"
						v-if="scope.row.status.index==11 "
					>删除</el-button>
				</template>
			</template>
		</curd-table>
	</div>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import FilterWarehouse from "@/mixins/Filter/FilterWarehouse.js";
import FilterSupplier from "@/mixins/Filter/FilterSupplier";
import FilterStatus from "@/mixins/Filter/FilterStatus.js";
import FilterExpressType from "@/mixins/Filter/FilterExpressType";
import { mapState, mapGetters, mapMutations } from "vuex";

import TxOp from "@/mixinsApp/TxOp.js";
import SupplierInput from "@/widgets/Inputs/SupplierInput";
import StockTable from "@/views/Inventory/subs/StockTable.vue";

const TX_TYPE_OUTBOUND = 20;
const TX_TYPE_INBOUND = 21;
const TX_TYPE_SCHEDULE = 40;
const TX_TYPE_ST = 31;
const TX_TYPE_ST_OUTCOME = 32;
const TX_TYPE_ST_INIT = 99;

export default {
  components: {SupplierInput},
  mixins: [CurdPage, Filters, FilterWarehouse, FilterExpressType, FilterStatus, TxOp, FilterSupplier],
	data() {
		return {
			loadings: {
				main: false,
				create: false,
				warehouse: false,
			},
			filterHisDate: [],
			filterTableSearch: "",
			listDataModel: "Transaction",
			editorId: "",
			tableFields: [
				{
					name: "show_id",
					isTrans: false,
					sortable: "custom",
				},
				{
					name: "name",
					isTrans: false,
					sortable: false,
					width: "400px",
				},
				{
					name: "warehouse",
					isTrans: true,
					sortable: "custom",
					isTag: true,
				},
				"__targetByType__",

				{
					name: "updated_at",
					isTrans: false,
					sortable: false,
				},
				{
					name: "status",
					isTrans: false,
					sortable: false,
				},
			],
			expandTableFields: [
				{
					name: "desc",
				},
			],
		};
	},
	props: {
		type: {
			type: Array,
			default: function() {
				return [];
			},
		},
	},
	computed: {
		...mapState(["userPrivilegeMapping"]),
	},
	watch: {
		type: {
			handler() {
				this.baseKv = [{ k: "type", v: this.type, t: "int", lge: "in" }];
			},
			immediate: true,
		},
	},
	created() {
		this.replaceTableFields();
	},
	mounted() {},
	methods: {
		replaceTableFields() {
			let index = -1;
			for (let k in this.tableFields) {
				if (
					typeof this.tableFields[k] == "string" &&
					this.tableFields[k] == "__targetByType__"
				) {
					index = k;
				}
			}
			if (index == -1) {
				return;
			}
			this.tableFields.splice(index, 1);
			for (let k in this.type) {
				if (this.type[k] == TX_TYPE_INBOUND) {
					this.tableFields.splice(index, 0, {
						name: "supplier",
						sortable: "custom",
					});
				} else if (this.type[k] == TX_TYPE_OUTBOUND) {
					this.tableFields.splice(index, 0, {
						name: "customer",
						sortable: "custom",
						width: "90px",
					});
					this.tableFields.splice(index, 0, {
						name: "express_type",
						render: info => {
							return "[" + info.express_type.name + "] " + info.address.name;
						},
					});
					this.tableFields.splice(index, 0, {
						name: "order",
						params: {
							link: "Order-Info",
						},
						sortable: false,
					});
					this.tableFields.splice(index, 0, {
						name: "express",
						sortable: false,
					});
					this.tableFields.splice(index, 0, {
						name: "tracking_number",
						sortable: false,
					});
				} else if (this.type[k] == TX_TYPE_ST) {
					this.tableFields.splice(index, 0, {
						name: "type",
						sortable: "custom",
					});
					this.tableFields.splice(index, 0, {
						name: "created_user",
					});
				}
			}
			if (this.userPrivilegeMapping[59]) {
				this.tableFields.splice(index, 0, {
					name: "total_price",
					isTrans: false,
					sortable: false,
				});
			}
		},

		refreshTable() {
			this.$refs["listTable"].refreshData();
		},
	},
};
</script>
<style lang="scss" scoped>
</style>
